import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpService, NotificationService } from '../../../tms-shared';
import { TmsWebBaseEditService } from '../base';
import {
  ProductBillOfMaterial,
  ProductPurchaseOrderHistory,
  ProductSalesOrderHistory,
  StockEnquiryByProduct,
  StockEnquiryProductHistory,
  StockItemProductEnquiry,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class StockEnquiryService extends TmsWebBaseEditService<StockEnquiryByProduct, StockEnquiryByProduct> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('StockEnquiry', $localize`Stock Enquiry`, httpService, notificationService);
  }

  getStockEnquiryHistory(id: string): Observable<StockEnquiryProductHistory[]> {
    return this.httpService.get<StockEnquiryProductHistory[]>(`${this.apiUrl}/StockEnquiryHistory/${id}`);
  }

  getStockEnquirySalesOrderHistory(id: string, search: string): Observable<ProductSalesOrderHistory[]> {
    return this.httpService.get<ProductSalesOrderHistory[]>(
      `${this.apiUrl}/StockEnquirySalesOrderHistory?id=${id}&search=${search}`,
    );
  }

  getStockEnquirySalesOrderHistoryCustomer(id: string, customerId: string): Observable<ProductSalesOrderHistory[]> {
    return this.httpService.get<ProductSalesOrderHistory[]>(
      `${this.apiUrl}/StockEnquirySalesOrderHistoryCustomer?id=${id}&customerId=${customerId}`,
    );
  }

  getStockEnquiryPurchaseOrderHistory(id: string, search: string): Observable<ProductPurchaseOrderHistory[]> {
    return this.httpService.get<ProductPurchaseOrderHistory[]>(
      `${this.apiUrl}/StockEnquiryPurchaseOrderHistory?id=${id}&search=${search}`,
    );
  }

  getStockEnquiryForBillOfMaterials(id: string): Observable<ProductBillOfMaterial[]> {
    return this.httpService.get<ProductBillOfMaterial[]>(`${this.apiUrl}/StockEnquiryForBillOfMaterials/${id}`);
  }

  getStockItemsForProduct(id: string, includeAll: boolean): Observable<StockItemProductEnquiry[]> {
    return this.httpService.get<StockItemProductEnquiry[]>(
      `${this.apiUrl}/StockItemsForProduct?id=${id}&includeAll=${includeAll}`,
    );
  }
}
